import { useContext, useEffect } from 'react'
import { UserContext } from '../context/UserContext'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

const ProtectedRoute = ({ children }) => {
    const { loggedInUser, loading, logOutReason, setLogOutReason } = useContext(UserContext)
    const navigate = useNavigate()

    useEffect(() => {
        if (!loading && loggedInUser === null) {
            if (logOutReason === "silent-timeout") {
                navigate("/")
                setLogOutReason(null)
                return
            }
            toast.error("Sorry, please log in to continue!")
            navigate("/login")
        }
    }, [loggedInUser, loading, logOutReason, navigate, setLogOutReason])

    if (loading) return (
        <section className='container'>
            <p>Loading...</p>
        </section>
    )

  return children
}

export default ProtectedRoute